module.exports = __webpack_public_path__ + "media/images/icons/icon-lightbulb-alt-5ab31b0e252a424a1b64268e8a09e18e.svg";